<template>
<div class="page-container">
  <customer-groups ref="customerGroups" :selected-users="selectedCustomers" :current-group-id="queryParams.customerGroupId" @filter="selectCustomerGroup" @changed="getTableData" />
  <div class="card-title" v-show="showSearch">
    <el-form size="small" :label-width="$locale === 'en' ? '110px' : '68px'" :model="queryParams" ref="queryForm">
      <el-row :gutter="48">
        <el-col :md="6" :sm="24">
          <el-form-item :label="$t('用户名')">
            <el-input v-model="queryParams.username" class="search-item" :placeholder="$t('请输入用户名')" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="6" :sm="24">
          <el-form-item :label="$t('状态')">
            <el-select v-model="queryParams.status" :placeholder="$t('请选择用户状态')" class="search-item" clearable>
              <el-option v-for="dict in dict.type.sys_active_state" :key="dict.value" :label="dict.label" :value="dict.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="6" :sm="24">
          <!-- 创建时间 -->
          <el-form-item :label="$t('创建时间')">
            <el-date-picker
              v-model="queryParams.dataRange"
              class="search-item"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="-"
:start-placeholder="$t('开始日期')"
:end-placeholder="$t('结束日期')"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <div class="search-content">
          <!-- 搜索按钮 -->
          <el-form-item class="search-button">
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">{{ $t('搜索') }}</el-button>
            <el-button icon="el-icon-refresh" size="mini" @click="handleReset">{{ $t('重置') }}</el-button>
            <el-button
              type="text"
              :icon="advanced ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
              class="advanced-button"
              @click="toggleAdvanced">
              {{ advanced ? $t('关闭') : $t('展开') }}
            </el-button>
          </el-form-item>
        </div>
      </el-row>
    </el-form>
  </div>
  <div class="card">
    <el-row :gutter="10" class="button-container">
      <el-col :span="1.5">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd" size="mini" plain>
          {{ $t('新增') }}
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button type="success" icon="el-icon-edit" size="mini" plain :disabled="single" @click="handleUpdate">{{ $t('编辑') }}</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" :columns="columns" @getTableData="reloadUsersAndGroups"></right-toolbar>
    </el-row>

    <el-table ref="userTable" v-loading="loading" :element-loading-text="$t('正在加载表格数据')" :data="tableData" @selection-change="handleSelectionChange" border>
      <template slot="empty">
        <el-empty :image-size="200"></el-empty>
      </template>
      <el-table-column type="selection" width="50" align="center" :selectable="row => row.roles === 'ROLE_DEFAULT'" />
      <!-- 用户名 -->
      <el-table-column prop="username" :label="$t('用户名')" align="center" v-if="columns[0].visible"><template slot-scope="scope"><span data-i18n-ignore>{{ scope.row.username }}</span></template></el-table-column>
      <!-- 昵称 -->
      <el-table-column prop="nickname" :label="$t('昵称')" align="center" v-if="columns[1].visible"><template slot-scope="scope"><span data-i18n-ignore>{{ scope.row.nickname }}</span></template></el-table-column>
      <el-table-column :label="$t('客户分组')" min-width="170" align="center"><template slot-scope="scope"><template v-if="scope.row.roles === 'ROLE_DEFAULT'"><span>{{ groupLabel(scope.row) }}</span></template><span v-else>—</span></template></el-table-column>
      <!-- 头像 -->
      <el-table-column prop="avatar" :label="$t('头像')" align="center" v-if="columns[2].visible" width="90">
        <template slot-scope="scope">
          <el-image :src="scope.row.avatar">
            <div slot="error" class="image-slot-table">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </template>
      </el-table-column>
      <!-- 状态 -->
      <el-table-column prop="status" :label="$t('状态')" align="center" v-if="columns[3].visible" width="100">
        <template slot-scope="scope">
          <el-switch v-if="scope.row.roles !== 'ROLE_ADMIN'" v-model="scope.row.status" :disabled="statusSavingId === scope.row.id" active-color="#13ce66" inactive-color="#ff4949" @change="handleUserStatus(scope.row)"></el-switch>
          <el-switch v-else disabled v-model="scope.row.status" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="roleName" :label="$t('角色')" align="center" v-if="columns[4].visible">
        <template slot-scope="scope">
          <span data-i18n-ignore>{{ displayRoleName(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('操作')" align="center" :width="$locale === 'en' ? 550 : 460">
        <template slot-scope="scope" v-if="scope.row.roles !== 'ROLE_ADMIN'">
          <el-button type="text" size="small" icon="el-icon-edit" @click="handleUpdate(scope.row)">{{ $t('编辑') }}</el-button>
          <el-button type="text" size="small" icon="el-icon-s-operation" @click="openInitialSurcharge(scope.row)">{{ $t('初始附加费') }}</el-button>
          <el-button type="text" size="small" icon="el-icon-wallet" @click="openDepositTarget(scope.row)">{{ $t('押金阈值') }}</el-button>
          <el-button type="text" size="small" icon="el-icon-refresh-left" @click="handleResetPassword(scope.row)">{{ $t('重置密码') }}</el-button>
          <el-dropdown v-if="scope.row.roles === 'ROLE_DEFAULT'" class="row-group-menu" @command="command => handleGroupCommand(command, scope.row)"><el-button type="text" size="small" icon="el-icon-folder">{{ $t('分组') }}<i class="el-icon-arrow-down el-icon--right" /></el-button><el-dropdown-menu slot="dropdown"><el-dropdown-item command="move">{{ $t('加入分组') }}</el-dropdown-item><el-dropdown-item command="remove" :disabled="String(scope.row.customerGroupId || '1') === '1'">{{ $t('移出分组') }}</el-dropdown-item></el-dropdown-menu></el-dropdown>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页器 -->
    <pagination
      :background="false"
      :total="total"
      :page.sync="queryParams.currentPage"
      :limit.sync="queryParams.pageSize"
      @pagination="getTableData"
    />
  </div>

  <!-- 用户信息对话框 -->
  <el-dialog
    :title="userTitle"
    width="600px"
    :modal-append-to-body="true"
    :append-to-body="true"
    :close-on-click-modal="false"
    :visible="userVisible"
    :before-close="handleClose">
    <div class="dialog-wrapper" v-loading="userLoading" :element-loading-text="$t('正在加载用户信息')">
      <el-form ref="userForm" :model="formData" :rules="rules" :label-width="$locale === 'en' ? '170px' : '100px'" label-position="right">
        <el-row :gutter="10">
          <el-col :span="12">
            <!-- 用户名 -->
            <el-form-item :label="$t('用户名')" prop="username">
              <el-input v-model="formData.username" :placeholder="$t('请输入用户名')" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- 昵称 -->
            <el-form-item :label="$t('用户昵称')" prop="nickname">
              <el-input v-model="formData.nickname" :placeholder="$t('请输入用户昵称')" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item v-if="!formData.id" :label="$t('初始密码')" prop="password">
          <el-input v-model="formData.password" type="password" show-password :placeholder="$t('请输入至少6位初始密码')" clearable></el-input>
        </el-form-item>
        <el-row :gutter="10">
          <el-col :span="12">
            <!-- 电话号码 -->
            <el-form-item :label="$t('电话号码')" prop="phone">
              <el-input v-model="formData.phone" :placeholder="$t('请绑定电话号码')" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- 状态 -->
            <el-form-item :label="$t('状态')" prop="status">
              <el-radio-group v-model="formData.status">
                <el-radio :label="true">{{ $t('正常') }}</el-radio>
                <el-radio :label="false">{{ $t('停用') }}</el-radio>
            </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item v-if="!formData.id" :label="$t('初始附加费')" prop="initialSurchargePercent">
          <div class="field-control">
            <el-input-number v-model="formData.initialSurchargePercent" :min="0" :max="1000" :precision="2" :step="1" controls-position="right" class="field-number" />
            <span class="field-unit">%</span>
          </div>
          <p class="field-help">{{ $t('填写后应用于该客户全部产品；客户单品配置优先。不填写则使用产品通用比例') }}</p>
        </el-form-item>
        <el-form-item v-if="!formData.id" :label="$t('初始押金阈值')" prop="depositTarget">
          <div class="field-control">
            <el-input-number v-model="formData.depositTarget" :min="0" :max="99999999.99" :precision="2" :step="100" controls-position="right" class="field-number" />
            <span class="field-unit">USD</span>
          </div>
          <p class="field-help">{{ $t('该客户应维持的押金金额，决定充值时需要补足的缺口') }}</p>
        </el-form-item>
        <!-- 备注 -->
        <el-form-item :label="$t('备注')" prop="remark">
          <el-input v-model="formData.remark" type="textarea" :placeholder="$t('请输入备注')" clearable></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer">
      <el-button type="danger" :loading="buttonLoading" @click="handleClose()" size="small" icon="el-icon-error">{{ $t('取消') }}</el-button>
      <el-button type="success" :loading="buttonLoading" @click="submitForm()" size="small" icon="el-icon-success">{{ $t('保存') }}</el-button>
    </div>
  </el-dialog>

  <!-- 为指定客户设置全部产品的默认附加费 -->
  <el-dialog
:title="$t('设置初始附加费')"
    width="460px"
    :visible.sync="surchargeVisible"
    :append-to-body="true"
    :close-on-click-modal="false">
    <div class="surcharge-dialog" v-loading="surchargeLoading">
      <div class="surcharge-user">{{ $t('客户：') }}<strong>{{ surchargeUser.nickname || surchargeUser.username || '-' }}</strong></div>
      <el-form label-width="112px">
        <el-form-item :label="$t('初始附加费')">
          <el-input-number v-model="surchargePercent" :min="0" :max="1000" :precision="2" :step="1" controls-position="right" />
          <span class="form-tip">%</span>
        </el-form-item>
      </el-form>
      <p class="surcharge-help">{{ $t('保存后应用于该客户全部产品；已配置的客户单品比例保持优先。填写 0% 表示该客户默认不加价。') }}</p>
    </div>
    <div slot="footer">
      <el-button size="small" @click="surchargeVisible = false">{{ $t('取消') }}</el-button>
      <el-button type="primary" size="small" :loading="surchargeLoading" @click="saveInitialSurcharge">{{ $t('保存') }}</el-button>
    </div>
  </el-dialog>

  <deposit-target-dialog :visible.sync="depositTargetVisible" :user="depositTargetUser" @saved="getTableData" />

  <el-dialog
:title="$t('密码重置成功')"
    width="440px"
    :visible.sync="resetPasswordVisible"
    :append-to-body="true"
    :close-on-click-modal="false">
    <el-alert :title="$t('请及时保存密码，关闭后将无法再次查看。')" type="warning" :closable="false" show-icon />
    <div class="reset-password-result">
      <span>{{ $t('新密码') }}</span>
      <el-input :value="generatedPassword" readonly>
        <el-button slot="append" icon="el-icon-document-copy" @click="copyGeneratedPassword">{{ $t('复制') }}</el-button>
      </el-input>
    </div>
    <div slot="footer">
      <el-button type="primary" size="small" @click="resetPasswordVisible = false">{{ $t('我已保存') }}</el-button>
    </div>
  </el-dialog>

</div>
</template>
<script>
import CustomerGroups from './CustomerGroups'
import { customerGroupLabel } from './customerGroupLabels'
import DepositTargetDialog from '../../transport/DepositTargetDialog'
import { translateUi } from '../../../i18n'
import Pagination from '../../../components/Pagination/index'
import RightToolbar from '../../../components/RightToolbar/index'
import { listUsers, insert, getUserInfoById, updateUser, updateUserStatus, resetPassword, updateInitialSurchargeRate } from '../../../api/user'

export default {
  name: 'User',

  dicts: ['sys_active_state'],

  components: { Pagination, RightToolbar, DepositTargetDialog, CustomerGroups },

  data () {
    return {
      // 高级搜索 展开/关闭
      advanced: false,
      // 是否展示搜索内容
      showSearch: true,
      // 数据总条数
      total: 0,
      selectedCustomers: [],
      userListRevision: 0,
      // 用户对话框是否显示
      userVisible: false,
      surchargeVisible: false,
      surchargeLoading: false,
      surchargeUser: {},
      surchargePercent: null,
      depositTargetVisible: false,
      depositTargetUser: {},
      resetPasswordVisible: false,
      generatedPassword: '',
      // 数据表格等待框
      loading: false,
      statusSavingId: null,
      // 查询参数
      queryParams: {
        // 页数
        currentPage: 1,
        customerGroupId: undefined,
        // 页面大小
        pageSize: 20,
        // 用户名
        username: undefined,
        // 状态
        status: undefined,
        // 时间范围
        dataRange: []
      },
      // 用户表单对象
      formData: {
        // 用户名
        username: undefined,
        // 昵称
        nickname: undefined,
        // 电话号码
        phone: undefined,
        // 状态
        status: true,
        initialSurchargePercent: null,
        // 初始押金阈值，仅在新增客户时填写
        depositTarget: null,
        // 备注
        remark: undefined
      },
      // 用户表单校验规则
      rules: {
        // 用户名
        username: [{ required: true, get message () { return translateUi('用户名不能为空') }, trigger: 'blur' }],
        // 用户昵称
        nickname: [{ required: true, get message () { return translateUi('用户昵称不能为空') }, trigger: 'blur' }],
        // 初始密码仅在新增客户时显示
        password: [{ required: true, min: 6, get message () { return translateUi('初始密码至少需要6位') }, trigger: 'blur' }],
        // 状态
        status: [{ required: true, get message () { return translateUi('用户状态不能为空') }, trigger: 'blur' }],
        // 初始押金阈值仅在新增客户时显示
        depositTarget: [{ required: true, get message () { return translateUi('初始押金阈值不能为空') }, trigger: 'blur' }]
      },
      // 用户对话框等待框
      userLoading: false,
      // 对话框按钮等待框
      buttonLoading: false,
      // 列信息
      columns: [
        // 用户名
        { key: 0, get label () { return translateUi('用户名') }, visible: true },
        // 昵称
        { key: 1, get label () { return translateUi('昵称') }, visible: true },
        // 头像
        { key: 2, get label () { return translateUi('头像') }, visible: true },
        // 状态
        { key: 3, get label () { return translateUi('状态') }, visible: true },
        { key: 4, get label () { return translateUi('角色') }, visible: true }
      ],
      // 表格数据
      tableData: [],
      // 表头选中的数据
      ids: [],
      // 多数据停用
      single: true,
      // 对话框标题
      userTitle: ''
    }
  },

  mounted () {
    // 查询表格数据
    this.getTableData()
  },
  beforeDestroy () { this.userListRevision++ },

  methods: {
    displayRoleName (row) {
      if (row.roles === 'ROLE_ADMIN') return this.$t('超级管理员')
      if (row.roles === 'ROLE_DEFAULT') return this.$t('普通客户')
      return row.roleName || this.$t('未分配')
    },
    // 获取表格数据
    async getTableData () {
      const revision = ++this.userListRevision
      this.loading = true
      try {
        const res = await listUsers({ ...this.queryParams })
        if (revision !== this.userListRevision) return
        this.tableData = res.list
        this.total = res.total
        this.selectedCustomers = []; this.ids = []; this.single = true
        if (this.$refs.userTable) this.$refs.userTable.clearSelection()
      } catch (error) {
        if (revision === this.userListRevision) { this.tableData = []; this.total = 0; this.selectedCustomers = []; this.ids = []; this.single = true }
      } finally { if (revision === this.userListRevision) this.loading = false }
    },
    groupLabel (row) { return customerGroupLabel(row, this.$t) },
    selectCustomerGroup (groupId) {
      this.queryParams.customerGroupId = groupId || undefined
      this.queryParams.currentPage = 1
      this.selectedCustomers = []; this.ids = []; this.single = true
      if (this.$refs.userTable) this.$refs.userTable.clearSelection()
      return this.getTableData()
    },
    reloadUsersAndGroups () {
      if (this.$refs.customerGroups) this.$refs.customerGroups.loadGroups()
      return this.getTableData()
    },
    handleGroupCommand (command, row) {
      if (!this.$refs.customerGroups || row.roles !== 'ROLE_DEFAULT') return
      if (command === 'move') this.$refs.customerGroups.openMove([row])
      if (command === 'remove') this.$refs.customerGroups.remove([row])
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    // 点击查询按钮
    handleQuery () {
      this.queryParams.currentPage = 1
      this.getTableData()
    },
    // 点击重置按钮
    handleReset () {
      // 用户名
      this.queryParams.username = ''
      // 状态
      this.queryParams.status = ''
      // 创建时间
      this.queryParams.dataRange = []
    },
    // 打开用户信息对话框
    handleOpen () {
      // 清除表单数据
      this.reset()
      this.userVisible = true
    },
    // 关闭用户对话框表单
    handleClose () {
      this.reset()
      this.userVisible = false
    },
    openInitialSurcharge (row) {
      this.surchargeUser = row || {}
      this.surchargePercent = row && row.initialSurchargeConfigured
        ? Number(row.initialSurchargeRate || 0) * 100
        : null
      this.surchargeVisible = true
    },
    openDepositTarget (row) {
      this.depositTargetUser = row || {}
      this.depositTargetVisible = true
    },
    saveInitialSurcharge () {
      if (!this.surchargeUser.id) return
      if (this.surchargePercent === null || this.surchargePercent === '') {
        this.$message.error(translateUi('请填写初始附加费'))
        return
      }
      const percent = Number(this.surchargePercent)
      if (!Number.isFinite(percent) || percent < 0 || percent > 1000) {
        this.$message.error(translateUi('初始附加费必须在 0% 至 1000% 之间'))
        return
      }
      this.surchargeLoading = true
      updateInitialSurchargeRate(this.surchargeUser.id, percent / 100).then(() => {
        this.$message.success(translateUi('初始附加费已保存'))
        this.surchargeVisible = false
        this.getTableData()
      }).finally(() => {
        this.surchargeLoading = false
      })
    },
    // 重置用户密码
    handleResetPassword (row) {
      this.$confirm(this.$locale === 'en' ? `Reset the password for ${row.nickname}?` : translateUi('是否重置用户 ') + row.nickname + translateUi(' 的密码？'), translateUi('提示'), {
        confirmButtonText: translateUi('确定'),
        cancelButtonText: translateUi('取消'),
        type: 'warning'
      }).then(() => {
        // 执行重置用户密码方法
        resetPassword(row.id).then((password) => {
          this.generatedPassword = password
          this.resetPasswordVisible = true
        })
      }).catch(() => {})
    },
    async copyGeneratedPassword () {
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(this.generatedPassword)
        } else {
          const input = document.createElement('textarea')
          input.value = this.generatedPassword
          input.style.position = 'fixed'
          input.style.opacity = '0'
          document.body.appendChild(input)
          input.select()
          document.execCommand('copy')
          document.body.removeChild(input)
        }
        this.$message.success(translateUi('密码已复制'))
      } catch (error) {
        this.$message.error(translateUi('复制失败，请手动保存密码'))
      }
    },
    // 点击新增按钮
    handleAdd () {
      this.$setUiText('userTitle', '新增用户')
      this.handleOpen()
    },
    // 点击编辑按钮
    handleUpdate (row) {
      // 修改对话框标题
      this.$setUiText('userTitle', '更新用户')
      // 获取到传来的ID
      const userId = row.id || this.ids
      // 打开加载框
      this.userLoading = true
      // 打开编辑用户对话框
      this.userVisible = true
      // 根据用户ID获取对应的数据
      getUserInfoById(userId).then((res) => {
        // 赋值当前的用户数据
        this.formData = res
        // 关闭加载框
        this.userLoading = false
      }).catch(() => {
        this.closeLoading()
      })
    },
    // 更新用户状态
    handleUserStatus (row) {
      const targetStatus = row.status
      this.statusSavingId = row.id
      updateUserStatus(row.id, targetStatus).then(() => {
        this.$message.success(translateUi(targetStatus ? translateUi('用户已启用') : translateUi('用户已禁用')))
      }).catch(() => {
        row.status = !targetStatus
      }).finally(() => {
        this.statusSavingId = null
        this.getTableData()
      })
    },
    // 提交表单
    submitForm () {
      const that = this
      this.$refs.userForm.validate(valid => {
        // 校验未通过则直接返回
        if (!valid) return
        // 开启加载框
        that.buttonLoading = true
        that.userLoading = true
        // 如果存在用户ID则进行用户更新操作
        if (that.formData.id) {
          updateUser(that.formData).then((res) => {
            // 刷新表单数据并关闭对话框
            that.handleClose()
            // 输出更新成功信息
            that.$message.success(translateUi('用户更新成功'))
            // 刷新用户数据
            that.getTableData()
            // 关闭等待框
            that.closeLoading()
          }).catch(() => {
            // 关闭加载框
            that.closeLoading()
          })
        } else {
          const payload = { ...that.formData }
          if (that.formData.initialSurchargePercent !== null && that.formData.initialSurchargePercent !== '') {
            payload.initialSurchargeRate = Number(that.formData.initialSurchargePercent) / 100
          }
          delete payload.initialSurchargePercent
          // The threshold must be explicit at creation time so the first top-up
          // tops up towards it instead of defining it.
          payload.depositTarget = Number(that.formData.depositTarget || 0)
          insert(payload).then((res) => {
            // 输出添加成功消息
            that.$message.success(translateUi('用户添加成功'))
            if (that.$refs.customerGroups) that.$refs.customerGroups.loadGroups()
            // 刷新表单数据并关闭对话框
            that.handleClose()
            // 刷新用户数据
            that.getTableData()
            // 关闭加载框
            that.closeLoading()
          }).catch(() => {
            // 关闭加载框
            that.closeLoading()
          })
        }
      })
    },
    // 重置表单
    reset () {
      // 清除校验条件
      this.formData = {
        // 用户ID
        id: undefined,
        // 用户名
        username: undefined,
        // 初始密码
        password: undefined,
        // 电话号码
        phone: undefined,
        // 状态
        status: true,
        initialSurchargePercent: null,
        // 备注
        remark: undefined
      }
      // 清除表单的校验
      this.resetForm('userForm')
    },
    // 多选框
    handleSelectionChange (selection) {
      // 获取当前选中数组的ID
      this.selectedCustomers = selection.filter(item => item.roles === 'ROLE_DEFAULT')
      this.ids = this.selectedCustomers.map(item => item.id)
      // 表头的编辑是否可以点击
      this.single = this.selectedCustomers.length !== 1
    },
    // 关闭所有等待框
    closeLoading () {
      this.buttonLoading = false
      this.userLoading = false
    }
  }
}

</script>

<style lang="scss" scoped>
.row-group-menu { margin-left: 10px; }

.dialog-wrapper {
  padding: 10px 30px;
}
.surcharge-dialog {
  padding: 4px 18px 8px;
}
.surcharge-user {
  margin-bottom: 18px;
  padding: 12px 14px;
  border-radius: 6px;
  background: #f5f8fb;
  color: #607080;
}
.surcharge-user strong {
  color: #233b52;
}
.surcharge-help {
  margin: 2px 0 0 112px;
  color: #8997a5;
  font-size: 12px;
  line-height: 1.6;
}
.surcharge-dialog .el-input-number {
  width: 190px;
}
.form-tip {
  margin-left: 8px;
  color: #6f7f8e;
}
.field-control {
  display: flex;
  align-items: center;
}
.field-number {
  width: 220px;
}
.field-unit {
  margin-left: 8px;
  color: #6f7f8e;
  font-size: 13px;
}
.field-help {
  margin: 4px 0 0;
  color: #8997a5;
  font-size: 12px;
  line-height: 1.6;
}
</style>
